import { ErrorActorEvent } from 'xstate';
import { AuthMachineContext, AuthMachineEvents } from '../types';

export function addError({
  context,
  event,
}: {
  context: AuthMachineContext;
  event: AuthMachineEvents;
}) {
  if (!event.type.includes('xstate.error.actor')) return context;

  const e = event as unknown as ErrorActorEvent;
  return {
    errors: [...context.errors, String(e.error).replace('Error: ', '')],
  };
}

export default addError;
